import { Card, GridItem, SimpleGrid } from '@chakra-ui/react';
import ReservationGroupByConfirmationStatus from '@client/page/management/table-reservation/analytic-new/components/reservation-group-by-confirmation-status';
import ReservationGroupByGuest from '@client/page/management/table-reservation/analytic-new/components/reservation-group-by-guest';
import { useTranslate } from '@tolgee/react';
import dayjs from 'dayjs';
import { DateRange } from '../../common/reservation-analytic-service';
import ReservationHourDistributionReport from './reservation-hour-distribution-report';

export default function ReservationChartLayout({ dateRange }: { dateRange: DateRange }) {
  const { t } = useTranslate();
  return (
    <Card.Root>
      <Card.Header>
        <Card.Title fontWeight={'semibold'} fontSize={'xl'}>
          {t('reservation.chart.header', 'Chart')}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <SimpleGrid columns={{ base: 1, sm: 2 }} gapX={16} gapY={6} w={'full'}>
          <GridItem>
            <ReservationHourDistributionReport startTime={dateRange.startDate} endTime={dateRange.endDate} />
          </GridItem>

          <GridItem>
            <ReservationGroupByGuest startTime={dayjs(dateRange.startDate)} endTime={dayjs(dateRange.endDate)} />
          </GridItem>

          <GridItem>
            <ReservationGroupByConfirmationStatus
              startTime={dayjs(dateRange.startDate)}
              endTime={dayjs(dateRange.endDate)}
            />
          </GridItem>
        </SimpleGrid>
      </Card.Body>
    </Card.Root>
  );
}
